export default __webpack_public_path__ + "static/media/music-playerNC.3017a730.svg";